/**
 * SC Cart Radio Buttons
 */

//- Disclaimer Checkbox and button Disable
const purchaseButton = $('.cart--radioButtons .cta[data-param]');
const frequencyButton = $('.cart--radioButtons .subscribe-box__default');
const frequencyButtonSubscribe = $('.cart--radioButtons .subscribe-box__default.subscribe');
const closeDisclaimerButton = $('.cart--radioButtons #closeDisclaimer');
const disclaimerBox = $('.cart--radioButtons #disclaimerBox');
const disclaimerTrigger = $('.cart--radioButtons #disclaimerTrigger');
const subscribeMode = $('.cart--radioButtons #subscribeMode');
const subscribeCheckbox = $('.cart--radioButtons #subscribeCheckbox');

/**
 * UI: FrequencyButton Active State
 */
function frequencyButtonActive(el) {
    $(frequencyButton).removeClass('active');

    $(el).addClass('active');
}

/**
 * UI: Open Disclaimer Box
 */
function openDisclaimer() {
    disclaimerBox.addClass('open');
}

/**
 * UI: Close Disclaimer Box
 */
function closeDisclaimer() {
    disclaimerBox.removeClass('open');
}

/**
 * UI: Disable purchaseButton
 */
function disablePurchaseButton() {
    purchaseButton.addClass('disabled');
}

/**
 * UI: Enable purchaseButton
 */
function enablePurchaseButton() {
    purchaseButton.removeClass('disabled');
}

/**
 * Reset checkbox and data-attr - When checkbox is checked and click on one-time: checkbox not checked and data-attr = "false" 
 */
function setSubscribeMode() {
    disclaimerTrigger.addClass('checked');

    subscribeMode.attr('data-subscribe', 'true');
}

function resetSubscribeMode() {
    disclaimerTrigger.removeClass('checked');

    subscribeMode.attr('data-subscribe', 'false');
}

/**
 * UI: Handle Disclaimer Checkbox - enable / disable purchaseButton
 * Event: Add / Remove .checked and update data-checked value
 */
function selectSubscribeMode() {
    let subscribeState = subscribeMode.attr('data-subscribe');
    
    if(subscribeState == 'false') {
        setSubscribeMode();        
        enablePurchaseButton();
        
        // console.log("true", subscribeState);
        
    } else {
        resetSubscribeMode();
        disablePurchaseButton();
        
        // console.log("false", subscribeState);
    }
}

/**
 * Event: Handle FrequencyButton event (Subscription Mode)
 */
frequencyButton.on('click', function() {
    frequencyButtonActive(this);

    //- Open / Close Disclaimer Box
    if($(this).hasClass('subscribe')) {
        openDisclaimer();
        disablePurchaseButton();
        
    } else {
        closeDisclaimer();
        enablePurchaseButton();
    }

    if($(this).hasClass('active')) {
        resetSubscribeMode();
    }

    // setPurchaseLinks();

    $('.cart--radioButtons .cart__product.active').trigger("click");
});

/**
 * Handle disclaimerTrigger checkbox
 */
disclaimerTrigger.on('click', function(e) {
    e.preventDefault();

    selectSubscribeMode();
});

/**
 * Event: Handle Close Disclaimer Box event
 */
closeDisclaimerButton.on('click', function() {
    closeDisclaimer();
});

// Calculate Savings based on Frequency
function calculateSavings(subscribeState) {
    let products = $('.cart--radioButtons .cart__product'),
        retail = 'data-retail',
        price = 'data-price',
        shipping = 'data-shipping',
        priceSubscribe = 'data-subscribe-price',
        shippingSubscribe = 'data-subscribe-shipping',
        saveType = 'data-save-type';
        
    products.each(function() {
        let productSavingValue = $(this).find('.saving__value'),
            productShippindValue = $(this).find('.shipping__value'),
            retailVal = $(this).attr(retail),
            priceVal = $(this).attr(price),
            shippingVal = $(this).attr(shipping),
            priceSubscribeVal = $(this).attr(priceSubscribe),
            shippingSubscribeVal = $(this).attr(shippingSubscribe),
            saveTypeValue = $(this).attr(saveType);

        let savingDollar = Number(retailVal - priceVal).toFixed(2),
            savingSubscribeDollar = Number(retailVal - priceSubscribeVal).toFixed(2),
            savingPercentage = Number(100 - (priceVal / retailVal) * 100).toFixed(),
            savingSubscribePercentage = Number(100 - (priceSubscribeVal / retailVal) * 100).toFixed();

        if (subscribeState == true) {
            if (saveTypeValue == 'Dollar') {
                productSavingValue.html(savingSubscribeDollar);

            } else if (saveTypeValue == 'Percentage') {
                productSavingValue.html(savingSubscribePercentage);
            }

            productShippindValue.html(shippingSubscribeVal);
            
        } else {
            if (saveTypeValue == 'Dollar') {
                productSavingValue.html(savingDollar);
                
            } else if (saveTypeValue == 'Percentage') {
                productSavingValue.html(savingPercentage);
            }

            productShippindValue.html(shippingVal);            
        }        
    });
}

// Set Active Product
function updateSelectedProduct() {
    let thisProduct = $(this),
        amount = thisProduct.attr('data-units');
    let subscribeState = frequencyButtonSubscribe.hasClass('active');

    // console.log(subscribeState);

    const retail = thisProduct.attr('data-retail');
    
    let price = '-price', 
        shipping = '-shipping', 
        link = '-link',
        subscribe = '';

    $('.cart--radioButtons .cart__product').removeClass('active');
    thisProduct.addClass('active');

    $('#orderNow').removeClass(function (index, className) {
		return (className.match(/(^|\s)cart--unit\S+/g) || []).join(' ');
	}).addClass('cart--unit' + amount);
    
    if (subscribeState == true) {
        subscribe = '-subscribe';        
    }

    let pricePerUnit = parseFloat(thisProduct.attr('data' + subscribe + price) / amount).toFixed(2);

    // console.log(thisProduct.attr('data' + subscribe + price));

    calculateSavings(subscribeState);

    $('.cart--radioButtons .per-unit__units').html(amount);
    $('.cart--radioButtons .per-unit__value').html(pricePerUnit);
    $('.cart--radioButtons .offer__value').html(thisProduct.attr('data' + subscribe + price));
    $('.cart--radioButtons .price__value').html(thisProduct.attr('data' + price));
    $('.cart--radioButtons .price-subscribe__value').html(thisProduct.attr('data-subscribe' + price));
    $('.cart--radioButtons .summary .retail__value').html(retail);
    $('.cart--radioButtons .offerShipping__value').html(thisProduct.attr('data' + subscribe + shipping));

    if($('.cart--radioButtons-v02')) {
        let products = $('.cart__product');
        
        products.each(function() {
            let amount = $(this).attr('data-units');
            let pricePerUnit = parseFloat($(this).attr('data' + subscribe + price) / amount).toFixed(2);

            // console.log($(this).attr('data' + subscribe + price));
            // console.log(amount);
            // console.log(pricePerUnit);

            $(this).find('.offer__value').html($(this).attr('data' + subscribe + price));
            $(this).find('.per-unit__value').html(pricePerUnit);
        });
    }

    let param = $('.cart--radioButtons .cta').attr('data-param');

    if(thisProduct.attr('data' + subscribe + link).includes('?') == false) {
        param = '?' + param
    } else {
        param = '&' + param
    }

    $('.cart--radioButtons .cta').attr('href', thisProduct.attr('data' + subscribe + link) + param);
};

//- Events
$('.cart--radioButtons .cart__product').on('click', updateSelectedProduct);
$('.cart--radioButtons .cart__product.active').trigger("click");